import React, { FC, useState } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';
import { Box, Stack, Tab, Tabs } from '@mui/material';

// import useOrgId from 'src/hooks/useOrgId';
import BrowserTab from './Tabs/BrowserTab';
import CandidateTab from './Tabs/CandidateTab';
import FeatureFlagsTab from './Tabs/FeatureFlagsTab';
import TasksTab from './Tabs/TasksTab';
import TimezonesTab from './Tabs/TimezonesTab';

type Props = {
  onClose: () => void;
};

// const E2E_ORG_ID = 'c14d06f6-f99b-4812-90d3-0061c5b3224d';

const DevToolsModal: FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState('Browser');
  // const orgId = useOrgId();

  return (
    <Dialog
      dataTestId="app-dev-tools-modal"
      maxWidth="xl"
      open
      title={t('hiring-dashboard-dev-tools:dev-tools.title')}
      onClose={onClose}
      enableBackdropClickClose
      enableEscapeClose
    >
      <Box height={500}>
        <Stack spacing={1}>
          <Tabs
            id="app-dev-tools-modal-tabs"
            data-testid="app-dev-tools-modal-tabs"
            value={tab}
            onChange={(__, newValue) => setTab(newValue)}
          >
            <Tab
              id="app-dev-tools-modal-tab-browser"
              data-testid="app-dev-tools-modal-tab-browser"
              value="Browser"
              label={t('hiring-dashboard-dev-tools:dev-tools.tabs.browser')}
            />
            <Tab
              id="app-dev-tools-modal-tab-tasks"
              data-testid="app-dev-tools-modal-tab-tasks"
              value="Tasks"
              label={t('hiring-dashboard-dev-tools:dev-tools.tabs.tasks')}
            />
            <Tab
              id="app-dev-tools-modal-tab-timezones"
              data-testid="app-dev-tools-modal-tab-timezones"
              value="Timezones"
              label={t('hiring-dashboard-dev-tools:dev-tools.tabs.timezones')}
            />
            <Tab
              id="app-dev-tools-modal-tab-feature-flags"
              data-testid="app-dev-tools-modal-tab-feature-flags"
              value="Feature flags"
              label={t('hiring-dashboard-dev-tools:dev-tools.tabs.featureFlags')}
            />
            <Tab
              id="app-dev-tools-modal-tab-candidate"
              data-testid="app-dev-tools-modal-tab-candidate"
              value="Candidate"
              label={t('hiring-dashboard-dev-tools:dev-tools.tabs.candidate')}
            />
          </Tabs>

          {tab === 'Browser' && <BrowserTab />}

          {tab === 'Tasks' && <TasksTab />}

          {tab === 'Timezones' && <TimezonesTab />}

          {tab === 'Feature flags' && <FeatureFlagsTab />}

          {tab === 'Candidate' && <CandidateTab onClose={onClose} />}
        </Stack>
      </Box>
    </Dialog>
  );
};

export default DevToolsModal;
